import React, { useMemo } from "react";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

function ToolTip({ className = "", text }) {
  const tooltipContent = useMemo(() => {
    if (!text) return null;

    return (
      <span style={{ display: "block", maxWidth: 300, zIndex: 1000, whiteSpace: "pre-line" }}>
        {text}
      </span>
    );
  }, [text]);

  return (
    <Tooltip title={tooltipContent} arrow placement="right">
      <InfoOutlinedIcon
        className={`infoicon ${className}`}
        sx={{ color: "gray", fontSize: 18, cursor: "pointer" }}
        aria-label="Information"
      />
    </Tooltip>
  );
}

export default React.memo(ToolTip);